import { RunTaskEntryStatus, RunTaskEntryType } from '../constants';
export function getVisibleEntries(_ref) {
  let {
    invocationId,
    automation,
    isRestoring,
    entries,
    startDate,
    isStopping,
    isTranslationsLoading,
    resolvedApprovalIds,
    hasTimedOut,
    t
  } = _ref;
  const fakeLoadingEntry = {
    type: RunTaskEntryType.Loading,
    status: RunTaskEntryStatus.Loading,
    date: startDate,
    title: ''
  };
  if (isTranslationsLoading) {
    return [fakeLoadingEntry];
  }
  const visibleEntries = entries.map(entry => ({
    ...entry,
    status:
    // Mark entry as loading when approving/rejecting
    entry.type === RunTaskEntryType.ToolCall && entry.approvalId && entry.status === RunTaskEntryStatus.Pending && resolvedApprovalIds.has(entry.approvalId) ? RunTaskEntryStatus.Loading : entry.status
  }));

  // Waiting for trigger entry
  if (automation && !isRestoring) {
    const isTriggerPending = !invocationId;
    const isTriggerLoading = !hasTimedOut && !isTriggerPending && !entries.length;
    const triggerEntry = {
      type: RunTaskEntryType.Trigger,
      status: hasTimedOut ? RunTaskEntryStatus.Failed : isTriggerPending ? RunTaskEntryStatus.Pending : RunTaskEntryStatus.Succeeded,
      date: startDate,
      title: t('trigger.title'),
      hasTimedOut,
      automation
    };
    if (isTriggerLoading) {
      visibleEntries.unshift(fakeLoadingEntry);
    }
    visibleEntries.unshift(triggerEntry);
  }

  // Loader as a fake entry
  if (visibleEntries.length === 0) {
    visibleEntries.unshift(fakeLoadingEntry);
  }
  const hasCompletedInvocation = visibleEntries.some(entry => entry.type === RunTaskEntryType.End);
  const hasPendingEntries = visibleEntries.some(entry => [RunTaskEntryStatus.Pending, RunTaskEntryStatus.Loading].includes(entry.status));

  // Mark last entry as loading
  if (visibleEntries.length > 0 && !hasCompletedInvocation && !hasTimedOut && (!hasPendingEntries || isStopping)) {
    const lastEntryIndex = visibleEntries.length - 1;
    visibleEntries[lastEntryIndex] = {
      ...visibleEntries[lastEntryIndex],
      status: RunTaskEntryStatus.Loading
    };
  }
  return visibleEntries;
}
//# sourceMappingURL=getVisibleEntries.js.map